import { ChatAvatar, initialOf } from "./chat-avatar";
import { VoiceMessage } from "./voice-message";
import { MessageReactions } from "./reactions";
import { cardLabel, reactionsFor, timeLabel } from "@lunary/app-core/reading-chat-model";
import type { ChatMessage, ChatPerson, ChatViewer } from "@lunary/app-core/reading-chat-model";
import styles from "./reading-chat.module.css";

type Props = {
  message: ChatMessage;
  viewer: ChatViewer;
  pending?: boolean;
  person?: ChatPerson;
  onReact?: (messageId: string, reaction: number | null) => void;
};

export function ReadingCards({ cards }: { cards: readonly number[] }) {
  if (cards.length === 0) return null;
  return (
    <div className={styles.cards}>
      {cards.map((c) => (
        <span key={c}>{cardLabel(c)}</span>
      ))}
    </div>
  );
}

export function ReadingBubble({
  message,
  viewer,
  pending = false,
  person,
  onReact,
}: Props) {
  const mine = message.author_role === viewer;
  const fromExpert = message.author_role === "expert";
  const voice = message.kind === "voice";
  const reactions = reactionsFor(message, viewer);
  return (
    <div className={`${styles.row} ${mine ? styles.me : ""}`}>
      {!mine && (
        <ChatAvatar
          src={
            message.author_avatar_url ?? (fromExpert ? null : person?.avatarUrl)
          }
          letter={fromExpert ? "Л" : initialOf(person?.name, "#")}
          muted={!fromExpert}
        />
      )}
      <MessageReactions
        className={styles.bubCol}
        align={mine ? "end" : "start"}
        mine={reactions.mine}
        other={reactions.other}
        onChange={
          onReact && !pending ? (next) => onReact(message.id, next) : undefined
        }
      >
        <div
          className={`${styles.bub} ${voice ? styles.bubVoice : ""}`}
          data-reactable=""
        >
          {voice && (
            <VoiceMessage
              id={message.id}
              src={message.audio_url}
              durationMs={message.duration_ms ?? 0}
              peaks={message.peaks}
              unheard={
                viewer === "user" && fromExpert && message.heard_at === null
              }
              mine={mine}
            />
          )}
          <ReadingCards cards={message.cards} />
          {message.body && (
            <p className={voice ? styles.caption : styles.text}>
              {message.body}
            </p>
          )}
          <span className={styles.meta}>
            {pending ? "отправляется…" : timeLabel(message.created_at)}
          </span>
        </div>
      </MessageReactions>
    </div>
  );
}
